import { foldersRefresh } from './foldersRefresh'
import { FoldersStore } from '../FoldersStore'
import { Folder } from '@/shared/interfaces/Folder'

export async function foldersLoad(): Promise<Folder[]> {
  const { foldersStore } = FoldersStore.get()

  const loadPromise = await foldersRefresh()

  await foldersStore.dispatch(async (state) => {
    state.foldersLoadPromise = loadPromise
  })

  const folders = loadPromise

  await foldersStore.dispatch(async (state) => {
    state.foldersLoadPromise = undefined
  })

  return folders
}
